import React, { PropTypes, Component } from 'react';
import cx from 'classnames';

const SCALE_TYPES = [
  {
    value: 'crop',
    label: 'Remplissage',
  },
  {
    value: 'fit',
    label: 'Respect Image',
  },
];

class NodeScaleType extends Component {
  static propTypes = {
    value: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this._onChange = this._onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
    });
  }

  _onChange(evt) {
    evt.preventDefault();

    const value = evt.currentTarget.dataset.value;
    if (value) {
      this.setState({
        value,
      });

      this.props.onChange(value);
    }
  }

  render() {
    const { disabled } = this.props;
    const { value } = this.state;

    const fieldClass = cx('field', {
      disabled,
    });

    const buttonClass = scaleType =>
      cx('ui button', {
        active: scaleType.value === value,
      });

    return (
      <div className={fieldClass}>
        <label>Opération</label>
        <div className="ui buttons">
          {SCALE_TYPES.map(g => (
            <button
              key={g.value}
              data-value={g.value}
              className={buttonClass(g)}
              onClick={this._onChange}
            >
              {g.label}
            </button>
          ))}
        </div>
      </div>
    );
  }
}

export default NodeScaleType;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/NodeScaleType.js